import script from "./navbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./navbar.vue?vue&type=script&setup=true&lang=ts"

import "./navbar.vue?vue&type=style&index=0&id=4747676e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4747676e"]])

export default __exports__